import React, { Component } from "react";
import { withFirebase } from "../Firebase";
import { compose } from "recompose";
import * as ROUTES from "../../constants/route";
import {
  GOOGLE_PLAY_LISTING_URL,
  APPLE_APP_STORE_LISTING_URL,
  HUAWEI_APP_GALLERY_LISTING_URL,
} from "../../constants/storeLinks";
import { Container, LinearProgress } from "@material-ui/core";
import Logo from "../../contents/img/Rampver_Online_Logo-main.png";
import googlePlayBadge from "../../assets/icons/google-play-store-badge.png";
import appStoreBadge from "../../assets/icons/apple-app-store-badge.png";
import appGalleryBadge from "../../assets/icons/huawei-appgallery-badge.png";
import axios from "axios";

const EmailVerificationPage = (props) => {
  return <EmailVerificationHandler props={props} />;
};

class EmailVerificationHandler extends Component {
  constructor(props) {
    super(props);

    this.state = {
      title: "Verifying Email",
      subtitle: "Please wait a moment",
      showStoreButtons: false,
    };

    this.fb = props.props.firebase;
    this.location = props.props.location;
    this.history = props.props.history;

    this.actionCode = new URLSearchParams(this.location.search).get("oobCode");
    this.mode = new URLSearchParams(this.location.search).get("mode");
    this.email = new URLSearchParams(this.location.search).get("email");
    switch (this.mode) {
      case "verifyEmail":
        this.fb
          .handleVerifyEmail(this.actionCode)
          .then(() => {
            return axios.post(
              `${ROUTES.FUNCTION_BASE_URL}clients-client/sendWelcome`,
              JSON.stringify({ token: this.actionCode }),
              {
                headers: {
                  "Content-Type": "application/json",
                },
              }
            );
          })
          .then((result) => {
            if (!result.data.ok) throw new Error(result.data.message);

            this.setState(
              {
                title:
                  "Congratulations! Your Rampver Online email has been verified.",
                subtitle:
                  "You can now open Rampver Online using the app links below.",
                showStoreButtons: true,
              }
            );
          })
          .catch((error) => {
            alert(error);
            this.setState(
              {
                title: "Failed to verify email.",
                subtitle:
                  "You will be redirected to back to the login page, please wait a moment...",
              },
              () => {
                setTimeout(() => {
                  this.history.push(ROUTES.SIGN_IN);
                }, 8000);
              }
            );
          });
        break;

      case "resetPassword":
        this.history.push({
          pathname: `/confirm-password/${this.actionCode}`,
          state: { code: this.actionCode },
        });
        break;
      default:
        this.history.push(ROUTES.SIGN_IN);
        break;
    }
  }

  render() {
    const { title, subtitle, showStoreButtons } = this.state;

    const storeLinks = [
      {
        id: "google-play",
        url: GOOGLE_PLAY_LISTING_URL,
        src: googlePlayBadge,
        alt: "Get it on Google Play",
        ariaLabel: "Get Rampver Online on Google Play",
      },
      {
        id: "app-store",
        url: APPLE_APP_STORE_LISTING_URL,
        src: appStoreBadge,
        alt: "Download on the App Store",
        ariaLabel: "Get Rampver Online on the App Store",
      },
      {
        id: "app-gallery",
        url: HUAWEI_APP_GALLERY_LISTING_URL,
        src: appGalleryBadge,
        alt: "Explore it on AppGallery",
        ariaLabel: "Get Rampver Online on Huawei AppGallery",
      },
    ].filter((item) => Boolean(item.url));

    return (
      <>
        <LinearProgress />
        <Container>
          <div id="message" className="r-title-container text-center">
            <img src={Logo} className="email-handler-img" alt="rampver-logo" />
            <br />
            <p className="r-title">{title}</p>
            <p className="r-subtitle">{subtitle}</p>
            {showStoreButtons && storeLinks.length > 0 ? (
              <div
                className="email-verification-store-links"
                role="group"
                aria-label="Download the mobile app"
              >
                {storeLinks.map((item) => (
                  <a
                    key={item.id}
                    className="email-verification-store-link"
                    href={item.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={item.ariaLabel}
                  >
                    <img
                      className="email-verification-store-badge"
                      src={item.src}
                      alt={item.alt}
                    />
                  </a>
                ))}
              </div>
            ) : null}
          </div>
        </Container>
      </>
    );
  }
}

export default compose(withFirebase)(EmailVerificationPage);

export { EmailVerificationHandler };
